import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { CustCatDropDown } from '@irb/irb-settings/settings-securities/settings-securities.model';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-delete-cell',
    template: `@if (removeDelete) {
  <div>
    @if (!_disableDelete) {
      <div class="btn-action-close-disable-delete"></div>
    }
    @if (!callBack && _disableDelete) {
      <div class="btn-action-close-delete" (click)="onDeleteClicked()" calltoaction [calltoactionTemplate]="deleteTemplateRef"></div>
    }
    @if (callBack && _disableDelete) {
      <div class="btn-action-close-delete" (click)="onDeleteClicked(); callBack(params.data)"></div>
    }
  </div>
}
<ng-template #deleteTemplateRef>
  <div class="block">{{params.message}}</div>
  @if (params.note) {
    <div class="block">{{params.note}}</div>
  }
  @if (deleteCustCat && deleteCustCat.items && deleteCustCat.items.length > 1) {
    <div class="block">
      It is already assigned to one or more securities.<br />Reassign them to
      <p-select [options]="deleteCustCat.items" optionLabel="name" placeholder="uncategorized" (onChange)="onCCSelect($event)"></p-select>
    </div>
  }
  <div class="buttonSet">
    <button (click)="cancel()" class="btn-medium-secondary">Cancel</button>
    <button (click)="delete()" class="btn-medium-primary">Remove</button>
  </div>
</ng-template>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteCellComponent implements AgRendererComponent, OnDestroy {
    
    params: any;
    _disableDelete: boolean = true;
    removeDelete: boolean = true; 
    callBack: Function;

    //_restrictions : Array<any>;

    _assignedCC: any;

    constructor(public iss:IrbSettingsService) {}

    agInit(params: any) {
        this.params = params;
        this.disableDelete();
        this.removeDeleteColumn();
        this.callBack = this.params.callBack || null;   
    }

    ngOnDestroy(): void {
        this.assignedCC = null;
    }

    onDeleteClicked(): void {
        if (this.params.data.categoryId) {
            this.iss.deleteCustCat(this.params.data.categoryId).subscribe((data: CustCatDropDown) => {
                this.deleteCustCat = data;
            });
        }
    }

    refresh(): boolean {
        return false;
    }

    cancel() {
        if(typeof this.params.cancel != "undefined") {
            this.params.cancel();
        }
    }

    disableDelete() {
        if(typeof this.params.disableDelete != "undefined") {
            this._disableDelete=this.params.disableDelete(this.params);
        }
    }
    removeDeleteColumn() {
        if(this.params.hide) {
            this.removeDelete=this.params.hide(this.params);
        } 
    }

    delete() {
        if(typeof this.params.proceed != "undefined") {
            if(this.assignedCC) {
                this.params.data.assignedCustCatId = this.assignedCC.id;
                this.params.data.assignedCustCatLabel = this.assignedCC.name;
            }
            this.params.proceed(this.params.data);
        }
        /* let catIds: number[] = [this.params.data.categoryId] ;
        this.iss.checkCategoryRestrictions(catIds).subscribe((data: ICheckCategoryRestrictionsResponse) => {
            if (data && data.responseStatus == "SUCCESS" && data.responseData) {
                this.restrictions = data.responseData;
            }
        }); */
    }

    _deleteCustCat: CustCatDropDown;

    get deleteCustCat() {
        return this._deleteCustCat;
    }
    
    set deleteCustCat(newDeleteCustCat: CustCatDropDown) {
        this._deleteCustCat = newDeleteCustCat;
    }

    onCCSelect(event: any) {
        this.assignedCC = event.value;
    }

    /* get restrictions() {
        return this._restrictions;
    }
    
    set restrictions(newRestrictions: Array<any>) {
        this._restrictions = newRestrictions;
    } */

    get assignedCC() {
        return this._assignedCC;
    }

    set assignedCC(newAssignedCC: any) {
        this._assignedCC = newAssignedCC;
    }
}
